import { Intent } from "@blueprintjs/core"
import CustomSpinner from "components/Atoms/CustomSpinner"
import SplashLoader from "components/Atoms/SplashLoader"
import OutletRedirectChild from "components/Molecules/OutletRedirectChild"
import React, { Suspense, useEffect, useState } from "react"
import mainRoutes from "routes/main.routes"
import Layout from "./Layout"

const Main = () => {
  const [isOnline, setStatus] = useState(window.navigator.onLine)
  const setOnline = () => setStatus(window.navigator.onLine)
  useEffect(() => {
    window.addEventListener("online", setOnline)
    window.addEventListener("offline", setOnline)
  }, [isOnline])

  if (!isOnline)
    return (
      <SplashLoader intent={Intent.DANGER}>
        Oops! Your computer seems offline.
        <br />
        Please check your internet connection.
      </SplashLoader>
    )

  return (
    <Layout>
      <Suspense fallback={<CustomSpinner />}>
        <OutletRedirectChild basePath="/d" children={mainRoutes} />
      </Suspense>
    </Layout>
  )
}

export default Main
